import {createRouter, createWebHistory} from 'vue-router';
import Product from "@/views/ProductCenter/Product.vue";
import About from "@/views/About us.vue";
import SolutionsHome from "@/views/Solutions/SolutionsHome.vue";
import Contact from "@/views/Contact.vue";
import Support from "@/views/Support.vue";
import CaseShow from "@/views/CaseShow/CaseShow.vue";
import CaseShowContent from "@/views/CaseShow/CaseShowContent.vue";
import ProductContent from "@/views/ProductCenter/productContent.vue";
import SolutionDetails from  "@/views/Solutions/SolutionDetails.vue"
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'


import component from "element-plus/es/components/tree-select/src/tree-select-option";
const routes = [

  {
    path: '/',
    name: 'Home',
    component: ()=>import('../views/Home/Home.vue'),
  },
  {
    path: '/Product',
    name: 'Product',
    component: Product
  },
  {
    path: '/About',
    name: 'About',
    component: About
  },
  {
    path: '/SolutionsHome',
    name: 'SolutionsHome',
    component: SolutionsHome
  },
  {
    path: '/Contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/Support',
    name: 'Support',
    component: Support
  },
  {
    path: '/CaseShow',
    name: 'CaseShow',
    component: CaseShow
},
//   {
//     path: '/CaseShow',
//     name: 'CaseShow', // 必须定义name
//     component: () => import('./views/CaseShow.vue'),
//     meta: { title: '案例详情' } // 使用meta替代state
//   },
  {
    path:'/ProductContent',
    name: 'ProductContent',
    component: ProductContent
  },
  {
    path:'/CaseShowContent',
    name: 'CaseShowContent',
    component: CaseShowContent
  },
  {
    path:'/SolutionDetails',
    name: 'SolutionDetails',
    component: SolutionDetails
  }

]
const router = createRouter({
  history: createWebHistory(),
  mode:'history',
  linkActiveClass:'active',
  routes
})


router.beforeEach((to, from, next)=>{
  NProgress.start()   // 开启进度条
  // some code ...
  NProgress.done()   // 关闭进度条
  next()
})
// 路由切换时显示进度条
export default router


